import HTTP from '@/utils/http'
import notification from '@/utils/notification'
import { ActionTypes } from '@/utils/consts'
import { save } from '@/utils/xfs'
import { markDirectoriesDashboardListStale } from '@/store/dashboardListStale'

export async function createDirectory (request) {
  const response = await HTTP.post('/directories', request)
  markDirectoriesDashboardListStale()
  return response.data.data
}

export async function list (query) {
  const response = await HTTP.get('/directories', { params: query })
  return response.data.data
}

export async function batchUpdate (request, headerAction) {
  const response = await HTTP.put('/directories', request, { headers: { 'X-CMS-Action': headerAction } })
  notification.handleResponseAlert(response)
  markDirectoriesDashboardListStale()
  return response.data.data
}

export async function getDirectory (id) {
  const response = await HTTP.get(`/directories/${id}`)
  return response.data.data
}

export async function updateDirectory (id, request, options, showNotification = true) {
  let { headerAction } = options
  try {
    const response = await HTTP.put(`/directories/${id}`, request, { headers: { 'X-CMS-Action': headerAction } })
    if (showNotification) {
      notification.handleResponseAlert(response)
    }
    markDirectoriesDashboardListStale()
    return response.data.data
  } catch (error) {
    notification.handleResponseError(error)
    throw error
  }
}

export async function changeDirectoryStatus (id, request, showNotification = true, headerAction) {
  const response = await HTTP.patch(`/directories/${id}`, request, { headers: { 'X-CMS-Action': headerAction } })
  if (showNotification) {
    notification.handleResponseAlert(response)
  }
  markDirectoriesDashboardListStale()
  return response.data.data
}

export async function deleteDirectory (id, showNotification = true) {
  const response = await HTTP.delete(`/directories/${id}`, { headers: { 'X-CMS-Action': ActionTypes.directories.delete } })
  if (showNotification) {
    notification.handleResponseAlert(response)
  }
  markDirectoriesDashboardListStale()
}

export async function generateLobbyExcel (buildingCode, request) {
  const response = await HTTP.post(`/directories/generateLobbyExcel/${buildingCode}`, request, { responseType: 'arraybuffer' })
  save(response)
}

export async function generateFloorExcel (request) {
  const response = await HTTP.post(`/directories/generateFloorExcel`, request, { responseType: 'arraybuffer' })
  save(response)
}

export async function logMaintainHistory (request) {
  const response = await HTTP.put('/directories/maintainHistory', request)
  return response
}

export async function listMaintainHistories (request) {
  const response = await HTTP.get('/directories/maintainHistory', { params: request })
  return response
}

export async function getReviewerHistories (request) {
  const response = await HTTP.get('/directories/reviewer/histories', { params: request })
  return response
}

export async function setReviewer (request, config) {
  const response = await HTTP.post('/directories/reviewer', request, config)
  return response
}
